import styled from "styled-components";

// Plano Análise: card de envio digital dos documentos (mobile primeiro).

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin: 0 0 16px;
  padding: 12px 14px;
  background: var(--principal-10);
  border-left: 3px solid var(--principal-50);
  border-radius: 0 8px 8px 0;

  > strong {
    font-size: 15px;
    line-height: 24px;
    color: #2e5d38;
  }

  > p {
    font-size: 15px;
    line-height: 22px;
    color: #2e5d38;
    margin: 0;
  }
`;

export const Trava = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin: 0 0 16px;
  padding: 12px 14px;
  background: var(--cinza-20);
  border-left: 3px solid var(--cinza-60);
  border-radius: 0 8px 8px 0;

  > strong {
    font-size: 15px;
    line-height: 24px;
    color: var(--cinza-100);
  }

  > p {
    font-size: 15px;
    line-height: 22px;
    color: var(--cinza-80);
    margin: 0;
  }
`;

export const Prazo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0 16px;

  svg {
    color: var(--principal-50);
  }

  p {
    font-size: 17px;
    line-height: 28px;
    color: var(--cinza-90);
    margin: 0;

    strong {
      color: var(--cinza-100);
    }
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 1.5rem;

  & + div {
    padding-top: 1.5rem;
    border-top: 1px solid var(--cinza-30);
  }

  &:last-child {
    padding-bottom: 0;
  }

  > p {
    &.title {
      font-size: 1.0625rem;
      line-height: 1.5rem;
      font-weight: 700;
      color: var(--cinza-100);
      margin-bottom: 0.25rem;
    }
    &.description {
      font-size: 0.9375rem;
      line-height: 1.5rem;
      color: var(--cinza-90);
      margin-bottom: 1rem;
    }
    &.ajuda {
      font-size: 0.875rem;
      line-height: 1.375rem;
      color: var(--cinza-70);
      margin: 8px 0 0;
    }
  }
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  border-radius: 8px;
  padding: 4px 12px 4px 8px;
  margin-bottom: 12px;
  gap: 10px;
  background: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};

  > p {
    font-size: 15px;
    line-height: 24px;
    font-weight: 700;
    margin: 0;
  }

  > svg {
    color: ${({ iconColor }) => iconColor};
  }
`;

export const Motivo = styled.div`
  width: 100%;
  margin: 0 0 12px;
  padding: 10px 12px;
  background: var(--erro-10);
  border-left: 3px solid var(--erro-50);
  border-radius: 0 8px 8px 0;
  font-size: 15px;
  line-height: 22px;
  color: #a70028;

  strong {
    display: block;
    margin-bottom: 2px;
  }
`;

export const Arquivo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 0 12px;
  padding: 12px;
  border: 1px solid var(--cinza-30);
  border-radius: 8px;
  background: var(--white);

  > div.linha {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--cinza-100);
    min-width: 0;

    svg {
      color: var(--principal-50);
      flex-shrink: 0;
    }

    button.abrir {
      background: none;
      border: 0;
      padding: 0;
      font: inherit;
      font-size: 15px;
      line-height: 24px;
      font-weight: 700;
      color: var(--principal-50);
      text-align: left;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }
  }

  > p.meta {
    font-size: 13px;
    line-height: 20px;
    color: var(--cinza-70);
    margin: 0;
  }
`;

export const Apostila = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  line-height: 24px;
  color: var(--cinza-90);
  cursor: pointer;
  min-height: 44px;

  input {
    width: 22px;
    height: 22px;
    accent-color: var(--principal-50);
    flex-shrink: 0;
  }

  &[aria-disabled="true"] {
    cursor: default;
    color: var(--cinza-70);
  }
`;

export const Acoes = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  width: 100%;
  margin-top: 4px;

  @media (min-width: 560px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const BotaoUpload = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  border-radius: 0.5rem;
  border: 1px solid var(--principal-50);
  background: ${({ primario }) => (primario ? "var(--principal-50)" : "var(--white)")};
  color: ${({ primario }) => (primario ? "var(--white)" : "var(--principal-50)")};
  font-size: 15px;
  line-height: 24px;
  font-weight: 700;
  cursor: pointer;

  &.camera {
    @media (min-width: 900px) {
      display: none;
    }
  }

  &[aria-disabled="true"] {
    opacity: 0.6;
    cursor: progress;
  }

  input {
    display: none;
  }
`;

export const BotaoSaibaMais = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 44px;
  margin-top: 8px;
  background: transparent;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  line-height: 1.5rem;
  font-weight: 700;
  padding: 0.625rem 0.625rem 0.625rem 1rem;
  border: 1px solid var(--neutro-30);
  color: var(--neutro-30);
  outline: none;
  cursor: pointer;

  &.black {
    background: var(--cinza-80);
    border: 0;
    color: var(--white);
  }
`;

export const LaudoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 4px 0 16px;
  padding: 14px;
  border: 1px solid var(--principal-50);
  border-radius: 8px;
  background: var(--principal-10);

  > div.linha {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--principal-50);

    p {
      font-size: 17px;
      line-height: 28px;
      font-weight: 700;
      margin: 0;
      color: var(--cinza-100);
    }
  }

  > p.texto {
    font-size: 15px;
    line-height: 22px;
    color: var(--cinza-80);
    margin: 0;
  }
`;

export const LaudoBotao = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  border-radius: 0.5rem;
  border: 0;
  background: var(--principal-50);
  color: var(--white);
  font-size: 17px;
  line-height: 28px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: progress;
  }
`;

export const LaudoBotaoSecundario = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 0.5rem;
  border: 1px solid var(--principal-50);
  background: var(--white);
  color: var(--principal-50);
  font-size: 15px;
  line-height: 24px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: progress;
  }
`;

export const Consultor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 0 16px;
  padding: 14px;
  border-left: 3px solid var(--atencao-50);
  border-radius: 0 8px 8px 0;
  background: var(--atencao-10);

  > strong {
    font-size: 17px;
    line-height: 26px;
    color: #573a00;
  }

  > p {
    font-size: 15px;
    line-height: 22px;
    color: #573a00;
    margin: 0;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    min-height: 44px;
    padding: 10px 12px;
    border-radius: 0.5rem;
    border: 0;
    background: var(--principal-50);
    color: var(--white);
    font-size: 15px;
    line-height: 24px;
    font-weight: 700;
    cursor: pointer;

    &:disabled {
      opacity: 0.6;
      cursor: progress;
    }
  }

  > p.confirmado {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2e5d38;
    font-weight: 700;

    svg {
      color: var(--principal-50);
    }
  }

  > span {
    font-size: 13px;
    line-height: 20px;
    color: var(--cinza-70);
  }
`;
